var render = function () {
  var _vm$application$appli, _vm$application$appli2, _vm$application$speci, _vm$application$cours, _vm$application$group, _vm$application$paidF, _vm$application$speci2, _vm$application$cours2, _vm$application$paidF2, _vm$application$educa;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "px-3"
  }, [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Тип заявления")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$appli = _vm.application.applicationType) === null || _vm$application$appli === void 0 ? void 0 : _vm$application$appli.name))])]), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Статус заявления")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$appli2 = _vm.application.applicationStatus) === null || _vm$application$appli2 === void 0 ? void 0 : _vm$application$appli2.name))])]), _c('v-col', {
    staticClass: "px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "title": "Текущая специальность",
      "font-size": "15",
      "text-start": ""
    }
  })], 1), _c('v-col', {
    staticClass: "px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Специальность")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$speci = _vm.application.specialityFrom) === null || _vm$application$speci === void 0 ? void 0 : _vm$application$speci.name))])]), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Номер курса")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$cours = _vm.application.courseNumberFrom) === null || _vm$application$cours === void 0 ? void 0 : _vm$application$cours.name))])]), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Группа")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$group = _vm.application.group) === null || _vm$application$group === void 0 ? void 0 : _vm$application$group.name))])]), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Тип обучения")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$paidF = _vm.application.paidFormFrom) === null || _vm$application$paidF === void 0 ? void 0 : _vm$application$paidF.name))])]), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Форма обучения")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s(_vm.application.educationFormFrom.name))])]), _c('v-col', {
    staticClass: "px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "title": "Желаемая специальность",
      "font-size": "15",
      "text-start": ""
    }
  })], 1), _c('v-col', {
    staticClass: "px-0 border-top",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Специальность")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$speci2 = _vm.application.specialityTo) === null || _vm$application$speci2 === void 0 ? void 0 : _vm$application$speci2.name))])]), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Номер курса")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$cours2 = _vm.application.courseNumberTo) === null || _vm$application$cours2 === void 0 ? void 0 : _vm$application$cours2.name))])]), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Тип обучения")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$paidF2 = _vm.application.paidFormTo) === null || _vm$application$paidF2 === void 0 ? void 0 : _vm$application$paidF2.name))])]), _c('v-col', {
    staticClass: "pt-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "accent--text font-weight-bold"
  }, [_vm._v("Форма обучения")]), _c('div', {
    staticClass: "accent--text"
  }, [_vm._v(_vm._s((_vm$application$educa = _vm.application.educationFormTo) === null || _vm$application$educa === void 0 ? void 0 : _vm$application$educa.name))])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }